import React, { useState, useEffect, useRef } from 'react';
import { AWS_CONFIG } from '../config/aws';
import CoverflowCarousel from './CoverflowCarousel';
import PhotoGridModal from './PhotoGridModal';

// Customer photo section displayed directly below the hero banner.
// Loads /images?category=customer-photos and renders an equal-size row
// carousel: every card is the same width laid out in a row, the active one
// centered + highlighted by opacity, advancing one photo at a time (auto-rotate
// + manual arrows/dots). Only translateX animates, so the row never jitters.
// A "전체 보기" button opens a grid modal; picking a photo there jumps the
// carousel to it (decision ①). Hidden when 0 images (no placeholder).

const SECTION_TITLE = '고객님과 함께한 중고차';

export default function CustomerPhotoPanorama() {
  const [images, setImages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  // Imperative jump target for the carousel when a grid photo is picked.
  const jumpToRef = useRef(null);

  useEffect(() => {
    fetch(`${AWS_CONFIG.apiUrl}/images?category=customer-photos`)
      .then(r => r.json())
      .then(data => {
        const items = (data.images || [])
          .filter(i => i.imageUrl)
          .map(i => ({ src: i.imageUrl, alt: i.alt || SECTION_TITLE }));
        setImages(items);
      })
      .catch(() => {});
  }, []);

  if (images.length === 0) return null;

  return (
    <section className="section" style={{ background: 'var(--surface)' }}>
      <div className="container">
        <h2 className="section-title">{SECTION_TITLE}</h2>
        <p className="section-subtitle">
          KOA DETAILING을 통해 새 차주를 만난 순간
        </p>

        {/* maxWidth 1160(.container 가용폭): 중앙 카드를 작업 갤러리(960px)와
            동일감으로 키움(2026-06-29, CARD_W_DESKTOP 84%). 양옆은 살짝만 보이는
            코버플로우 유지. translateX만 움직여 들썩임 없음. */}
        <div style={{ maxWidth: 1160, margin: '0 auto' }}>
          <CoverflowCarousel
            images={images}
            intervalMs={3000}
            aspectRatio="4 / 3"
            jumpToRef={jumpToRef}
            onSelect={() => setModalOpen(true)}
          />

          {images.length > 1 && (
            <div style={{ textAlign: 'center', marginTop: 18 }}>
              <button
                type="button"
                className="btn btn-outline"
                style={{ padding: '8px 20px', fontSize: '0.9rem' }}
                onClick={() => setModalOpen(true)}
              >
                📷 전체 보기
              </button>
            </div>
          )}
        </div>
      </div>

      <PhotoGridModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        images={images}
        title={SECTION_TITLE}
        onPick={(i) => jumpToRef.current && jumpToRef.current(i)}
      />
    </section>
  );
}
